import { unsafeCSS } from 'lit';
const record = {
    hover: '-hovered',
};
const colors = {
    cssBackground: (color, type) => unsafeCSS(`
      background-color: var(--sgdf-color-bg-${color}${type ? record[type] : ''});
    `),
    cssColor: (color) => unsafeCSS(`
      color: var(--sgdf-color-${color});
    `),
};
const fontSizeMap = {
    L: 'large',
    M: 'medium',
    S: 'small',
    XS: 'x-small',
    XXS: '2x-small',
};
const texts = {
    cssHeading: unsafeCSS(`
      font-family: var(--sgdf-font-sans);
      font-size: var(--sgdf-font-size-large);
      ine-height: var(--sgdf-line-height-loose);
      font-weight: bold;
      text-transform: uppercase;
    `),
    cssSubtitle: unsafeCSS(`
      font-family: var(--sgdf-font-sans);
      font-size: var(--sgdf-font-size-large);
      line-height: var(--sgdf-line-height-normal);
      font-weight: var(--sgdf-font-weight-normal);
    `),
    cssBody: (weight, size = 'M') => unsafeCSS(`
      font-family: var(--sgdf-font-sans);
      font-size: var(--sgdf-font-size-${fontSizeMap[size]});
      line-height: var(--sgdf-line-height-${['L', 'M'].includes(size) ? 'dense' : 'denser'});
      font-weight: var(--sgdf-font-weight-${weight});
    `),
};
const recordPaddingSize = {
    XXXS: '3x-small',
    XXS: '2x-small',
    XS: 'x-small',
    S: 'small',
    M: 'medium',
};
const spacings = {
    cssPaddingX: (size) => unsafeCSS(`
      padding-right: var(--sgdf-spacing-${recordPaddingSize[size]});
      padding-left: var(--sgdf-spacing-${recordPaddingSize[size]});
    `),
    cssPaddingY: (size) => unsafeCSS(`
      padding-top: var(--sgdf-spacing-${recordPaddingSize[size]});
      padding-bottom: var(--sgdf-spacing-${recordPaddingSize[size]});
    `),
    cssPadding: (size) => unsafeCSS(`${spacings.cssPaddingX(size)}
          ${spacings.cssPaddingY(size)}`),
};
const recordBorderRadiusSize = {
    L: 'large',
};
const cssBorderRadius = (size) => unsafeCSS(`
    border-radius: var(--sgdf-border-radius-${recordBorderRadiusSize[size]})
  `);
// const paddingX: Record<PaddingSize: > =
export const theme = { colors, texts, spacings, cssBorderRadius };
export const FunctionColor = {
    LJ: '#ff8300',
    SG: '#0077b3',
    PC: '#d03f15',
    Compa: '#007254',
    Farf: '#65bc99',
    Audace: '#00395c',
    Groupe: '#6e74aa',
    Territoire: '#6e74aa',
    National: '#F0F0F0',
    Salarie: '#CCCCCC',
    Autre: '#888888',
    Impeesa: '#AA6600',
};
//# sourceMappingURL=theme.js.map